export function getStep(min: number, max: number): number {
    const range = max - min;
    const step = (max - min) / (range / 100);
    return step;
}